"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_BUILD_EXCLUDE_PATTERNS = exports.BUILD_REPORT_FILE_NAME = void 0;
exports.BUILD_REPORT_FILE_NAME = 'crazygames_build_report.json';
// on DP we want to exclude these custom build files from the total size warnings, as these are loaded only on specific devices
// it is quite problematic to fetch there the contents of the build report and detect the files based on it at the moment
// so we rely on this filename regex to exclude them
exports.CUSTOM_BUILD_EXCLUDE_PATTERNS = [/^max_1024mb_.*\.wasm\.br$/, /^astc_.*\.data\.br$/, /^max_512mb_.*\.wasm\.br$/];
